// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2m2J9jqL1Kf061LeqcPk7Z","iconCloseWrapper":"_3G5IQ3jDnu7Nx0-Qvswaa-","cropper":"TR6qEfgX2Xv036XSFvzMW","buttonsWrapper":"_7knRrFaigkDWLtECNgG4I","rotateLeft":"_2EF4kxJgMGoQN2ModsG9df","processModal":"_2aSb7RwGqa7Fk3eBOJK4LU","processOverlay":"au1aFLqJIzowLoN6qYLJa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cropper/Cropper.scss
// module id = 771
// module chunks = 0